// Mock data for Jump en Joy - springkastelen verhuur
// NOTE: This data is mocked for the frontend-only phase. It will be replaced
// by real backend data (products + availability + reservations) later.

export const siteInfo = {
  name: 'Jump en Joy',
  tagline: 'Springplezier voor groot en klein',
  phone: '+31 6 19 92 93 98',
  phoneRaw: '+31619929398',
  email: 'info@jumpenjoyverhuur.nl',
  region: 'Levering in de hele regio',
  hours: 'Ma-zo · 8:00 - 20:00',
  announcement: 'Snelle levering & opbouw door heel Nederland \u00b7 Reserveer vandaag voor jouw feest',
  whatsapp: '31619929398',
  instagram: 'https://www.instagram.com/jumpenjoyverhuur',
  tiktok: 'https://www.tiktok.com/@jumpenjoyverhuur',
  logo: '/logo.png',
};

export const heroVideo = '/hero.mp4';

// Mega dropdown categories for "Onze springkussens" (3x3 grid with mini images)
export const megaCategories = [
  { label: 'Prinsessenkastelen', desc: 'Sprookjesachtig roze', icon: 'Crown', img: 'https://white-dagger-2t27d.sites.repaint.com/images/prod-prinses.webp', to: '/onze-luchtkastelen/prinsessenkasteel' },
  { label: 'Peuterkastelen', desc: 'Voor de allerkleinsten', icon: 'Baby', img: 'https://white-dagger-2t27d.sites.repaint.com/images/prod-peuter.webp', to: '/onze-luchtkastelen/peuterkasteel' },
  { label: 'Glijbanen', desc: 'Spectaculaire glijpret', icon: 'Waves', img: 'https://white-dagger-2t27d.sites.repaint.com/images/cat-glijbanen.webp', to: '/onze-luchtkastelen?cat=Glijbanen' },
  { label: 'Multiplay combo\u2019s', desc: 'Springen & glijden', icon: 'Combine', img: 'https://white-dagger-2t27d.sites.repaint.com/images/prod-multiplay.webp', to: '/onze-luchtkastelen/multiplay-combo' },
  { label: 'Stormbanen', desc: 'Hindernisplezier', icon: 'Flag', img: 'https://white-dagger-2t27d.sites.repaint.com/images/cat-stormbanen.webp', to: '/onze-luchtkastelen?cat=Stormbanen' },
  { label: 'Thema kastelen', desc: 'Voor elk feestthema', icon: 'Sparkles', img: 'https://images.unsplash.com/photo-1740033135773-bf7c886ae45a?w=400&q=70', to: '/onze-luchtkastelen?cat=Springkussens' },
  { label: 'Waterpret', desc: 'Verfrissend zomerplezier', icon: 'Droplets', img: 'https://images.pexels.com/photos/6379672/pexels-photo-6379672.jpeg?w=400&q=70', to: '/onze-luchtkastelen?cat=Glijbanen' },
  { label: 'XXL attracties', desc: 'Groots uitpakken', icon: 'Trophy', img: 'https://images.unsplash.com/photo-1633846799243-d28b399143cc?w=400&q=70', to: '/onze-luchtkastelen?cat=Stormbanen' },
  { label: 'Bekijk ons hele assortiment', desc: 'Alle springkussens op een rij', icon: 'LayoutGrid', to: '/onze-luchtkastelen', cta: true },
];

// Veiligheidscertificaten
export const certificates = [
  { name: 'TÜV gekeurd', info: 'Gecertificeerd met de TÜV veiligheidskeuring voor opblaasbare speeltoestellen.' },
  { name: 'EN 14960', info: 'Voldoet aan de Europese norm EN 14960 voor opblaasbare speeltoestellen.' },
  { name: 'Volledig verzekerd', info: 'Gecertificeerd en verzekerd voor verhuur en evenementen.' },
  { name: 'Jaarlijks geïnspecteerd', info: 'Al ons materiaal wordt jaarlijks gecontroleerd en gereinigd.' },
];

// Three highlighted categories shown under the hero
export const categorySections = [
  { title: 'Springkussens', text: 'De klassieker waar kinderen urenlang op springen.', img: 'https://white-dagger-2t27d.sites.repaint.com/images/cat-kastelen.webp', to: '/onze-luchtkastelen?cat=Springkussens' },
  { title: 'Glijbanen', text: 'Spectaculaire glijpret voor groot en klein.', img: 'https://white-dagger-2t27d.sites.repaint.com/images/cat-glijbanen.webp', to: '/onze-luchtkastelen?cat=Glijbanen' },
  { title: 'Stormbanen', text: 'De ultieme uitdaging vol hindernissen.', img: 'https://white-dagger-2t27d.sites.repaint.com/images/cat-stormbanen.webp', to: '/onze-luchtkastelen?cat=Stormbanen' },
];

// Filter & sort options for the products page
export const filterOptions = {
  soorten: ['Springkussens', 'Glijbanen', 'Stormbanen'],
  andere: ['Suikerspin & Popcorn'],
  leeftijden: ['3-12 jaar', '6+ jaar', 'Alle leeftijden'],
  formaten: ['Middel', 'Groot', 'XL'],
  personen: ['Tot 6', '6 - 10', '10+'],
  themas: ['Prinses', 'Combo', 'Circus', 'Unicorn', 'Jungle', 'Comics', 'Voetbal', 'Sport', 'Stormbaan', 'Glijbaan'],
  locaties: ['Tuin', 'Binnen/zaal', 'Openbaar terrein'],
  evenementen: ['Verjaardag', 'Schoolfeest', 'Bedrijfsevent', 'Buurtfeest'],
  priceMin: 0,
  priceMax: 400,
};

export const sortOptions = [
  { value: 'populair', label: 'Populairst' },
  { value: 'price-asc', label: 'Prijs: laag → hoog' },
  { value: 'price-desc', label: 'Prijs: hoog → laag' },
  { value: 'nieuwst', label: 'Nieuwste' },
  { value: 'grootte', label: 'Op grootte' },
];

export const navItems = [
  { label: 'Springkussens', to: '/onze-luchtkastelen', mega: true },
  { label: 'Popcorn en Suikerspin', to: '/onze-luchtkastelen?cat=Suikerspin & Popcorn', food: true },
  { label: 'Over ons', to: '/', hash: 'over-ons' },
  { label: 'FAQ', to: '/', hash: 'faq' },
  { label: 'Contact', to: '/contact' },
];

export const categories = ['Alles', 'Springkussens', 'Glijbanen', 'Stormbanen', 'Suikerspin & Popcorn'];

export const heroImage = 'https://images.unsplash.com/photo-1633846850057-f8e8217b7c48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxib3VuY2UlMjBjYXN0bGV8ZW58MHx8fHwxNzgyMDc0MDc2fDA&ixlib=rb-4.1.0&q=85';

export const products = [
  {
    slug: 'klassiek-springkasteel',
    name: 'Klassiek springkasteel',
    category: 'Springkussens',
    tagline: 'De alleskunner voor elk verjaardagsfeest',
    description:
      'Ons klassieke springkasteel is een echte topper voor verjaardagen en tuinfeesten. Met hoge veiligheidswanden en een ruim springvlak springen de kinderen veilig en urenlang plezier.',
    capacity: '8-10 kinderen',
    size: '4 \u00d7 4 m',
    height: '3,5 m',
    power: '230V stopcontact',
    price: 90,
    image: 'https://white-dagger-2t27d.sites.repaint.com/images/cat-kastelen.webp',
    features: ['Inclusief blower', 'Veiligheidswanden', 'Levering & opbouw', 'Grondzeil en verankering'],
    bookedDates: ['2026-06-27', '2026-06-28', '2026-07-04', '2026-07-05', '2026-07-12', '2026-07-18'],
  },
  {
    slug: 'prinsessenkasteel',
    name: 'Prinsessenkasteel',
    category: 'Springkussens',
    tagline: 'Een sprookjesachtig kasteel voor de kleine prinsesjes',
    description:
      'Het prinsessenkasteel betovert elk feestje met zijn roze torens en sprookjesachtige uitstraling. Perfect voor verjaardagen met een thema waar dromen uitkomen.',
    capacity: '6-8 kinderen',
    size: '4 \u00d7 5 m',
    height: '3,5 m',
    power: '230V stopcontact',
    price: 110,
    image: 'https://white-dagger-2t27d.sites.repaint.com/images/prod-prinses.webp',
    features: ['Inclusief blower', 'Veiligheidswanden', 'Levering & opbouw', 'Grondzeil en verankering'],
    bookedDates: ['2026-06-24', '2026-06-25', '2026-07-01', '2026-07-11', '2026-07-19'],
  },
  {
    slug: 'peuterkasteel',
    name: 'Peuterkasteel',
    category: 'Springkussens',
    tagline: 'Veilig en laagdrempelig speelplezier voor de allerkleinsten',
    description:
      'Speciaal ontworpen voor peuters met lage instap en zachte wanden. Zo kunnen ook de allerkleinsten veilig en zorgeloos springen onder toezicht.',
    capacity: '4-6 peuters',
    size: '3 \u00d7 3 m',
    height: '2,5 m',
    power: '230V stopcontact',
    price: 75,
    image: 'https://white-dagger-2t27d.sites.repaint.com/images/prod-peuter.webp',
    features: ['Inclusief blower', 'Lage instap', 'Levering & opbouw', 'Grondzeil en verankering'],
    bookedDates: ['2026-06-26', '2026-07-03', '2026-07-10', '2026-07-17'],
  },
  {
    slug: 'glijbaan-xl',
    name: 'Glijbaan XL',
    category: 'Glijbanen',
    tagline: 'Spectaculaire glijpret voor groot en klein',
    description:
      'De Glijbaan XL zorgt voor uren spanning en plezier. Met zijn hoge glijvlak en zacht landingskussen is dit dé attractie voor elk groot feest.',
    capacity: 'tot 12 kinderen',
    size: '6 \u00d7 4 m',
    height: '5 m',
    power: '230V stopcontact',
    price: 140,
    image: 'https://white-dagger-2t27d.sites.repaint.com/images/cat-glijbanen.webp',
    features: ['Inclusief blower', 'Hoog glijvlak', 'Levering & opbouw', 'Grondzeil en verankering'],
    bookedDates: ['2026-06-27', '2026-07-04', '2026-07-05', '2026-07-25'],
  },
  {
    slug: 'multiplay-combo',
    name: 'Multiplay combo',
    category: 'Glijbanen',
    tagline: 'Springen, klimmen en glijden in \u00e9\u00e9n attractie',
    description:
      'De Multiplay combo combineert een springkasteel, klimwand en glijbaan in \u00e9\u00e9n. Eindeloos afwisselend speelplezier dat kinderen urenlang bezighoudt.',
    capacity: '10-12 kinderen',
    size: '6 \u00d7 5 m',
    height: '4 m',
    power: '230V stopcontact',
    price: 160,
    image: 'https://white-dagger-2t27d.sites.repaint.com/images/prod-multiplay.webp',
    features: ['Inclusief blower', 'Klimwand & glijbaan', 'Levering & opbouw', 'Grondzeil en verankering'],
    bookedDates: ['2026-06-28', '2026-07-11', '2026-07-12', '2026-07-26'],
  },
  {
    slug: 'stormbaan',
    name: 'Stormbaan',
    category: 'Stormbanen',
    tagline: 'De ultieme uitdaging voor competitief feestplezier',
    description:
      'Twee parallelle banen vol hindernissen, tunnels en obstakels. Wie is het snelst aan de finish? De stormbaan is ideaal voor school- en bedrijfsevents.',
    capacity: '2 banen',
    size: '12 \u00d7 3 m',
    height: '3 m',
    power: '230V stopcontact',
    price: 180,
    image: 'https://white-dagger-2t27d.sites.repaint.com/images/cat-stormbanen.webp',
    features: ['Inclusief blower', 'Twee banen', 'Levering & opbouw', 'Grondzeil en verankering'],
    bookedDates: ['2026-06-29', '2026-07-06', '2026-07-13', '2026-07-20'],
  },
];

export const getProductBySlug = (slug) => products.find((p) => p.slug === slug);

export const features = [
  {
    icon: 'Truck',
    title: 'Levering & opbouw',
    text: 'Wij brengen, plaatsen veilig en halen weer op.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Veilig & gekeurd',
    text: 'Schoon materiaal met grondzeil en verankering.',
  },
  {
    icon: 'Sparkles',
    title: 'Voor elk feest',
    text: 'Van verjaardagen tot school- en bedrijfsevents.',
  },
];

export const steps = [
  'Kies & reserveer je springkussen',
  'Wij leveren & bouwen veilig op',
  'Springen maar, wij halen het weer op',
];

export const faqItems = [
  {
    q: 'Waar verhuren jullie?',
    a: 'Wij verhuren springkussens door heel Nederland.',
  },
  {
    q: 'Hoe ver op voorhand moet ik reserveren?',
    a: 'We raden aan om minimaal 2 weken van tevoren te reserveren, vooral tijdens het hoogseizoen (lente en zomer). Zo ben je verzekerd van de gewenste springkussen op jouw feestdatum.\n\nVia de beschikbaarheidskalender bij elk springkussen zie je direct welke dagen nog beschikbaar zijn, zodat je eenvoudig jouw reservering kunt plannen.',
  },
  {
    q: 'Is levering en opbouw inbegrepen?',
    a: 'Ja! Levering, opbouw, verankering en het ophalen van het springkussen zijn altijd bij de huurprijs inbegrepen. Jij hoeft alleen maar te genieten!',
  },
  {
    q: 'Welke ondergrond heb ik nodig?',
    a: 'Een vlakke ondergrond van voldoende grootte. Op gras verankeren we het springkussen met haringen en op verharding gebruiken we waterzakken.',
  },
  {
    q: 'Wat als het regent?',
    a: 'Lichte regen is geen probleem. Bij hevige wind of onweer raden we het gebruik van het springkussen af. Neem bij twijfel gerust contact met ons op.',
  },
  {
    q: 'Hoeveel stroom is er nodig?',
    a: 'Elk springkussen werkt op een standaard 230V stopcontact. Zorg ervoor dat er binnen 25 meter een stopcontact beschikbaar is.',
  },
];

export const aboutImage = 'https://images.unsplash.com/photo-1765947390226-c6c2b9f13ae8?crop=entropy&cs=srgb&fm=jpg&w=900&q=80';

export const aboutStats = [
  { value: '500+', label: 'Geslaagde feesten' },
  { value: '4,9', label: 'Google beoordeling' },
  { value: '8+', label: 'Unieke attracties' },
  { value: '100%', label: 'Veilig & gekeurd' },
];

export const eventTypes = [
  { icon: 'Cake', title: 'Verjaardagsfeesten', text: 'Maak van elke verjaardag een onvergetelijk springfeest.', img: 'https://images.unsplash.com/photo-1608790672275-309c02d888ff?crop=entropy&cs=srgb&fm=jpg&w=600&q=80', accent: 'pink' },
  { icon: 'GraduationCap', title: 'Schoolfeesten', text: 'Veilig en goedgekeurd materiaal voor scholen en kinderdagverblijven.', img: 'https://images.unsplash.com/photo-1774437791179-de2271960713?crop=entropy&cs=srgb&fm=jpg&w=600&q=80', accent: 'blue' },
  { icon: 'Building2', title: 'Bedrijfsevents', text: 'Familiedagen en teambuilding met een vrolijke twist.', img: 'https://images.unsplash.com/photo-1571129618841-7884a7a26c93?crop=entropy&cs=srgb&fm=jpg&w=600&q=80', accent: 'blue' },
  { icon: 'PartyPopper', title: 'Buurtfeesten', text: 'Breng de hele buurt samen rond een springkussen.', img: 'https://images.unsplash.com/photo-1770732165507-ca1a4c19f31a?crop=entropy&cs=srgb&fm=jpg&w=600&q=80', accent: 'pink' },
];
